var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 0l-5.36 8h-8v16h8l5.36 8h2.64v-32h-2.64zM20 4v4c0.68 0 1.36 0.080 2 0.24 3.44 0.88 6 4 6 7.76s-2.52 6.88-6 7.76c-0.64 0.16-1.32 0.24-2 0.24v4c1 0 1.92-0.16 2.88-0.36h0.12c5.2-1.32 9-6.040 9-11.64s-3.8-10.32-9-11.64c-0.92-0.24-1.96-0.36-3-0.36zM20 12v8c0.36 0 0.72-0.040 1-0.12 1.72-0.44 3-2.040 3-3.88s-1.24-3.44-3-3.88c-0.32-0.080-0.68-0.12-1-0.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.cb54a1185e6e7c6ed4ba188bfcfa7434.svg";
export { ForwardRef as ReactComponent };